type State = {
  attestation_modal: {
    open: boolean;
  };
};

type Action =
  | {
      type: "ATTESTATION_MODAL:OPEN";
    }
  | {
      type: "ATTESTATION_MODAL:CLOSE";
    }
  | {
      type: "RESET";
    };

export function init(state: Partial<State>): State {
  return {
    attestation_modal: {
      open: false,
    },
  };
}

export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case "ATTESTATION_MODAL:OPEN":
      return {
        ...state,
        attestation_modal: {
          open: true,
        },
      };
    case "ATTESTATION_MODAL:CLOSE":
      return {
        ...state,
        attestation_modal: {
          open: false,
        },
      };
    case "RESET":
      return init({});
    default:
      return state;
  }
}
